import React from "react";
import { ClipboardListIcon, FileSpreadsheetIcon, LineChartIcon, BrainIcon, DropletsIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { studyTools } from "../../data/content";
const icons = [FileSpreadsheetIcon, ClipboardListIcon, LineChartIcon, DropletsIcon, BrainIcon];
export function StudyToolsSection() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-320" data-mp="1vpge4m13m77y">
      <div className="mx-auto max-w-4xl" data-id="element-321" data-mp="1vmtwftkhubc0">
        <SectionHeading tone="dark" eyebrow="Plus — practical study tools" title="More than reading. A structured way to organize your learning." intro="The Hemodynamic Monitoring Blueprint™ also includes practical educational resources designed to complement the six volumes." data-id="element-322" data-mp="1qpu0wcl9sqz5" />

        <ul className="mt-10 space-y-3" data-id="element-323" data-mp="3g4i3jm426ujz">
          {studyTools.map((tool, i) => {
          const Icon = icons[i];
          return <li key={tool.title} className="flex gap-4 rounded-2xl bg-navy-800 p-5 ring-1 ring-white/10 sm:p-6" data-id="element-324" data-mp="345m8qo4nrdcu" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold" data-id="element-325" data-mp="3958k0s0xejj0">
                  <Icon className="h-6 w-6 text-navy" aria-hidden="true" data-id="element-326" data-mp="2u8821g8je2xq" />
                </span>
                <div data-id="element-327" data-mp="2z5q18ewr53sj">
                  <h3 className="text-lg font-extrabold leading-snug text-white" data-id="element-328" data-mp="2z7axqa2mmwt1">{tool.title}</h3>
                  <p className="mt-1.5 text-base leading-relaxed text-brand-sky" data-id="element-329" data-mp="3mxexg6cp2cer">{tool.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <SectionCta tone="dark" label="Get access to all 6 volumes" note="One-time payment of $27 USD · Digital educational collection" data-id="element-330" data-mp="3d6u0enco5fxy" />
      </div>
    </section>;
}